import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";
import {getAuthHeader, prepareJsonPayload} from "../store/utils";



export const fetchGptResponse = createAsyncThunk(
    'inference/fetchGptResponse',
    /**
     *
     * @param promptData {string} - The prompt to send to server to passthrough to GPT service
     * @param id {string} - The UUID of the prompt generated in useGptResponses hook
     * @param srcLocation {string, optional} - Where within the platform the prompt was generated
     * @param promptTemplate {string, optional} - The template used to generate the prompt
     * @param rejectWithValue
     */
    async ({ promptData, id, srcLocation, promptHeadKey }, { rejectWithValue }) => {
        try {
            const requestData = { prompt: promptData };
            if (promptHeadKey) {
                requestData.prompt_head = promptHeadKey;
            }
            const response = await fetch(`${HOSTNAME}/inference/general`,
                prepareJsonPayload({
                    data: requestData,
                    method: "POST"
                }));

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log("Data from GPT API", data)
            return { id, data, timestamp: new Date().toISOString(), srcLocation };  // Include UUID in the response
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const extractPortfoliosFromFile = createAsyncThunk(
  'inference/extractPortfoliosFromFile',
  async (file, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${HOSTNAME}/inference/extract/portfolios`, {
        method: 'POST',
        body: formData,
        headers: {
          ...getAuthHeader(),
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to extract portfolios from file');
      }

      const responseData = await response.json();
      console.log('RESPONSE DATA ', responseData);
      return { filename: file.name, data: responseData };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
